import { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";

import "../common/Util.css";
import "./paymentList.css";
import { ReactComponent as SearchIc } from "../../assets/svg/search.svg";
import { ReactComponent as ImportIc } from "../../assets/svg/import_ic.svg";
import { ReactComponent as AddIc } from "../../assets/svg/add_icon.svg";
import { ReactComponent as DownArrow } from "../../assets/svg/down_arror.svg";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import { ReactComponent as ThreeDotIC } from "../../assets/svg/three-dot-ic.svg";
import { ReactComponent as EmailView } from "../../assets/svg/email_view_ic.svg";
import { ReactComponent as ListView } from "../../assets/svg/list_view_ic.svg";
import { ReactComponent as SelectGrid } from "../../assets/svg/seelct_grid_ic.svg";
import { ReactComponent as SelectList } from "../../assets/svg/select_list_ic.svg";
import { ReactComponent as RarIc } from "../../assets/svg/rar_ic.svg";
import { ReactComponent as LarIc } from "../../assets/svg/lar_ic.svg";
import { ReactComponent as EditIc } from "../../assets/svg/edit_ic.svg";
import { ReactComponent as DeleteIc } from "../../assets/svg/delete_ic.svg";
import profileIc from "../../assets/png/profile-ic.png";
import { ReactComponent as CloseIc } from "../../assets/svg/close-modal.svg";
import { ReactComponent as FileAddIc } from "../../assets/svg/file_add.svg";
import { ReactComponent as PlusImageIc } from "../../assets/svg/plus_image.svg";
import { Dropdown, Toast, ToastContainer, Modal } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { Sidebar } from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import { useGlobal } from "../../GlobalContext";
import { getPaymentsAPI } from "./payment-api";
import SearchableDropdown from "../common/commonDropDown";
import ImportTemplateButtons from "../common/import-download-button";
import { ReactComponent as DownloadIc } from "../../assets/svg/download_Ics.svg";
import {
  downloadTemplateExcelApi,
  uploadExcelApi,
} from "../transaction/transaction_api";
import { downloadBase64File } from "../../services/file-download-service";
import ProfileImageModal from "../common/common-preview";
function PaymentListingPage() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;

  const navigate = useNavigate();
  const [deleteId, setDeleteId] = useState(null);

  const { rolePermissionList } = useGlobal();

  function checkPermission(menuName, permission) {
    return true;
  }
  const openFile = (fileUrl = "") => {
    if (!fileUrl) return;

    const cleanUrl = fileUrl.split("?")[0].toLowerCase();

    // 🖼 Images → popup
    if (
      cleanUrl.endsWith(".png") ||
      cleanUrl.endsWith(".jpg") ||
      cleanUrl.endsWith(".jpeg") ||
      cleanUrl.endsWith(".gif") ||
      cleanUrl.endsWith(".webp")
    ) {
      setSelectedProfile(fileUrl);
      setShowProfilePopup(true);
      return;
    }

    // 📄 PDF → open directly in browser
    if (cleanUrl.endsWith(".pdf")) {
      setSelectedProfile(fileUrl);
      setShowProfilePopup(true);
      return;
    }

    // 📊 Office files → Office Viewer
    if (
      cleanUrl.endsWith(".xls") ||
      cleanUrl.endsWith(".xlsx") ||
      cleanUrl.endsWith(".doc") ||
      cleanUrl.endsWith(".docx") ||
      cleanUrl.endsWith(".ppt") ||
      cleanUrl.endsWith(".pptx")
    ) {
      const officeViewerUrl =
        "https://view.officeapps.live.com/op/view.aspx?src=" +
        encodeURIComponent(fileUrl);

      window.open(officeViewerUrl, "_blank", "noopener,noreferrer");
      return;
    }

    // ⬇ Default → download / open
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };
  const [search, setSearch] = useState("");
  const [selectedSortby, setSelectedSortBy] = useState({
    value: "created_at",
    label: "Date created",
    dir: "desc",
  });
  const [stageSelect, setStageSelect] = useState({
    value: "",
    label: "All",
  });
  const [industrySelect, setIndustrySelect] = useState({
    value: "",
    label: "All",
  });
  const [gradeSelect, setGradeSelect] = useState({
    value: "",
    label: "All",
  });
  const [locationSelect, setLocationSelect] = useState({
    value: "",
    label: "All",
  });

  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [active, setActive] = useState("list");
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);

  const [paymentList, setPaymentList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);

  // Snackbar State
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [importLoading, setImportLoading] = useState(false);
  const [templateLoading, setTemplateLoading] = useState(false);

  // Template Download

  const [showImportModal, setShowImportModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleSelectExcelFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleExcelFileUploaded = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedFile(file);
    }
    if (event.target) {
      event.target.value = "";
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const file = e.dataTransfer.files?.[0];
    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (fileExtension === "xlsx" || fileExtension === "xls") {
        setSelectedFile(file);
      } else {
        alert("Only Excel file format (.xlsx, .xls) is supported.");
      }
    }
  };

  const handleUploadClick = async () => {
    if (!selectedFile) {
      alert("Please select a valid Excel file.");
      return;
    }
    setImportLoading(true);
    try {
      const base64String = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject("File reading failed");
        reader.readAsDataURL(selectedFile);
      });

      await uploadExcel(base64String);
      setShowImportModal(false);
      setSelectedFile(null);
    } catch (error) {
      console.error(error);
      alert("Failed to import file");
    } finally {
      setImportLoading(false);
    }
  };

  const downloadTemplateExcel = async () => {
    setTemplateLoading(true); // ✅ start loader

    try {
      const response = await downloadTemplateExcelApi("Payment");

      if (response?.status === 200 && response?.data?.success) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(true);
        handleSnackbarShow();

        const base64String = response.data.base64;
        const fileName = `Payment_template_${Date.now()}.xlsx`;

        downloadBase64File(base64String, fileName);
      } else {
        throw new Error("Template download failed");
      }
    } catch (error) {
      console.error(error);
      setSnackbarMessage(error.response.data.message);
      setSnackbarStatus(error.response.data.success);
      handleSnackbarShow();
    } finally {
      setTemplateLoading(false);
    }
  };
  const uploadExcel = async (base64String) => {
    try {
      const response = await uploadExcelApi("payment_upload", base64String);
      if (response.status === 200) {
        if (response.data.success === true) {
          const base64String = response.data.base64;
          const fileName =
            response.data.file_name ?? `Payment_${new Date().getTime()}.xlsx`;

          downloadBase64File(base64String, fileName);
          fetchPayments();
          setSnackbarMessage(response.data.message);
          setSnackbarStatus(response.data.success);
          handleSnackbarShow();
          return;
        }
      }
      setSnackbarMessage(response.data.message);
      setSnackbarStatus(response.data.success);
      handleSnackbarShow();
      if (response.data.base64 != null && response.data.base64 !== "") {
        const base64String = response.data.base64;
        const fileName = `Payment_${new Date().getTime()}.xlsx`;
        downloadBase64File(base64String, fileName);
      }
    } catch (error) {
      console.error("Error uploading Excel:", error);
      setSnackbarMessage("Error uploading file");
      setSnackbarStatus(false);
      handleSnackbarShow();
    }
  };
  const fetchPayments = useCallback(async () => {
    setLoading(true);
    try {
      const params = {
        limit: itemsPerPage,
        skip: itemOffset,
        search: search,
        sort_field:
          selectedSortby.value === "created_at" ? null : selectedSortby.value, // Default sort handled by backend if null
        sort_dir: selectedSortby.dir,
        status: stageSelect.value,
        industry: industrySelect.value,
        grade: gradeSelect.value,
        location: locationSelect.value,
      };

      const response = await getPaymentsAPI(params);
      if (response.success) {
        setPaymentList(response.payments || []);
        setTotalCount(response.total_rec || 0);
        setPageCount(response.total_pgs || 0);
      } else {
        setPaymentList([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error fetching payments:", error);
      setPaymentList([]);
    } finally {
      setLoading(false);
    }
  }, [
    itemsPerPage,
    itemOffset,
    search,
    selectedSortby,
    stageSelect,
    industrySelect,
    gradeSelect,
    locationSelect,
  ]);

  useEffect(() => {
    fetchPayments();
  }, [fetchPayments]);

  const handlePageClick = (event) => {
    const newOffset = event.selected * itemsPerPage;
    setItemOffset(newOffset);
    setCurrentPage(event.selected);
  };
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");
  return (
    <div className="d-flex">
      <ProfileImageModal
        show={showProfilePopup}
        onClose={() => setShowProfilePopup(false)}
        imageUrl={selectedProfile}
      />{" "}
      {/* Sidebar */}
      <Sidebar currentfile="Payment" />
      {/* Main Content */}
      <div className="rounded-4 flex-grow-1">
        <Navbar pageTitle="Payments" />
        <div className="bg-half-white p-2">
          <div className="bg-white rounded-4 p-3">
            {/* First Row: Header & Actions */}
            <div className="d-flex align-items-center justify-content-between mb-3">
              <div className="tab-container">
                <div
                  className="tab-item active"
                  onClick={() => navigate("/payment")}
                >
                  Vendor ({totalCount})
                </div>
                <div
                  className="tab-item inactive"
                  onClick={() => navigate("/payment/history")}
                >
                  History
                </div>
                <div
                  className="tab-item inactive"
                  onClick={() =>
                    navigate("/payment/history", {
                      state: { activeTab: "Reconciliation" },
                    })
                  }
                >
                  Reconciliation
                </div>
              </div>

              <div className="d-flex align-items-center gap-2">
                {/* Search */}
                <div className="search-wrapper d-flex align-items-center gap-2 px-3 py-2">
                  <SearchIc />
                  <input
                    type="text"
                    placeholder="Search..."
                    className="border-0 outline-0 rounded-3 fs-14 fw-500 textcolor"
                    value={search}
                    onChange={(e) => {
                      setSearch(e.target.value);
                      setItemOffset(0); // Reset to first page on search
                      setCurrentPage(0);
                    }}
                  />
                </div>

                <div
                  className="cursor-pointer my-box d-flex align-items-center justify-content-center gap-2 px-3"
                  onClick={() => navigate("/payment/create")}
                >
                  <AddIc style={{ width: "16px", height: "16px" }} />
                  <div className="fs-12 fw-600">New payment</div>
                </div>
                <div
                  className="my-import d-flex align-items-center justify-content-center gap-2"
                  style={{ height: "36px", cursor: "pointer" }}
                  onClick={() => setShowImportModal(true)}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <ImportIc style={{ width: "16px", height: "16px" }} />
                  </div>
                  <div className="fs-12 fw-600" style={{ lineHeight: "16px" }}>
                    Import
                  </div>
                </div>
              </div>
            </div>

            {/* Second Row: Filters */}
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex justify-content-start gap-3 flex-wrap">
                {/* Sort By */}
                <Dropdown>
                  <Dropdown.Toggle
                    variant="light"
                    className="d-flex align-items-center justify-content-between btnBorder bg-white rounded-3"
                    style={{ padding: "7px 12px" }}
                  >
                    <span className="fs-12 fw-400 textGrey me-1">
                      Sort by :
                    </span>
                    <span className="fs-12 fw-500 textPurple">
                      {selectedSortby.label}
                    </span>
                    <DownArrow className="ms-2 textPurple" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() =>
                        setSelectedSortBy({
                          value: "created_at",
                          label: "Date created",
                          dir: "desc",
                        })
                      }
                    >
                      Date created
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() =>
                        setSelectedSortBy({
                          value: "vendor_name",
                          label: "Vendor Name",
                          dir: "asc",
                        })
                      }
                    >
                      Vendor Name
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() =>
                        setSelectedSortBy({
                          value: "amount",
                          label: "Amount",
                          dir: "desc",
                        })
                      }
                    >
                      Amount
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                {/* Stage */}
                <Dropdown>
                  <Dropdown.Toggle
                    variant="light"
                    className="d-flex align-items-center justify-content-between btnBorder bg-white rounded-3"
                    style={{ padding: "7px 12px" }}
                  >
                    <span className="fs-12 fw-400 textGrey me-1">Status :</span>
                    <span className="fs-12 fw-500 textPurple">
                      {stageSelect.label}
                    </span>
                    <DownArrow className="ms-2 textPurple" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() =>
                        setStageSelect({ value: "", label: "All" })
                      }
                    >
                      All
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() =>
                        setStageSelect({
                          value: "Completed",
                          label: "Completed",
                        })
                      }
                    >
                      Completed
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() =>
                        setStageSelect({ value: "Partial", label: "Partial" })
                      }
                    >
                      Partial
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() =>
                        setStageSelect({ value: "Pending", label: "Pending" })
                      }
                    >
                      Pending
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                {/* Industry */}
                <div>
                  <SearchableDropdown
                    apiUrl={`${apiUrl}get_industry`}
                    placeholder="Industry"
                    value={industrySelect}
                    onSelect={(item) => {
                      setIndustrySelect(item);
                      setItemOffset(0);
                      setCurrentPage(0);
                    }}
                    handleClear={() => {
                      setIndustrySelect({ value: "", label: "All" });
                      setItemOffset(0);
                      setCurrentPage(0);
                    }}
                  />
                </div>

                {/* Grade */}
                <div>
                  <SearchableDropdown
                    apiUrl={`${apiUrl}get_grade`}
                    placeholder="Grade"
                    value={gradeSelect}
                    onSelect={(item) => {
                      setGradeSelect(item);
                      setItemOffset(0);
                      setCurrentPage(0);
                    }}
                    handleClear={() => {
                      setGradeSelect({ value: "", label: "All" });
                      setItemOffset(0);
                      setCurrentPage(0);
                    }}
                  />
                </div>

                {/* Location */}
                <div>
                  <SearchableDropdown
                    apiUrl={`${adminUrl}get_city`}
                    placeholder="Location"
                    value={locationSelect}
                    onSelect={(item) => {
                      setLocationSelect(item);
                      setItemOffset(0);
                      setCurrentPage(0);
                    }}
                    handleClear={() => {
                      setLocationSelect({ value: "", label: "All" });
                      setItemOffset(0);
                      setCurrentPage(0);
                    }}
                  />
                </div>
              </div>

              {/* View Toggle */}
              <div
                className="rounded-4 toggleBg d-flex mt-2"
                style={{
                  width: "80px",
                  height: "32px",
                  backgroundColor: "#f1f3f6",
                  padding: "4px",
                  gap: "4px",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {/* LIST BUTTON */}
                <div
                  onClick={() => setActive("list")}
                  className={`d-flex align-items-center justify-content-center rounded-3 ${
                    active === "list" ? "bg-primary1" : ""
                  }`}
                  style={{ width: "36px", height: "24px", cursor: "pointer" }}
                >
                  {active === "list" ? (
                    <ListView style={{ width: "16px", height: "16px" }} />
                  ) : (
                    <SelectList style={{ width: "16px", height: "16px" }} />
                  )}
                </div>

                {/* GRID BUTTON */}
                <div
                  onClick={() => setActive("grid")}
                  className={`d-flex align-items-center justify-content-center rounded-3 ${
                    active === "grid" ? "bg-primary1" : ""
                  }`}
                  style={{ width: "36px", height: "24px", cursor: "pointer" }}
                >
                  {active === "grid" ? (
                    <SelectGrid style={{ width: "16px", height: "16px" }} />
                  ) : (
                    <EmailView style={{ width: "16px", height: "16px" }} />
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* List View */}
          {active === "list" && (
            <div className="bg-white rounded-4 mt-3 w-100 p-3" style={{ overflowX: "auto" }}>
              <div style={{ minWidth: "900px" }}>
                {/* Table Header */}
              <div
                className="d-flex w-100 align-items-center px-2 py-2"
                style={{
                  backgroundColor: "#F2F2F2",
                  borderRadius: "8px 8px 0 0",
                }}
              >
                <div
                  className="fs-13 fw-700 textcolor flex-grow-1 px-3"
                  style={{ flex: 2 }}
                >
                  Vendor
                </div>
                <div
                  className="fs-13 fw-700 textcolor flex-grow-1 px-3"
                  style={{ flex: 1.5 }}
                >
                  Total Amount
                </div>
                <div
                  className="fs-13 fw-700 textcolor flex-grow-1 px-3"
                  style={{ flex: 1 }}
                >
                  Transactions
                </div>
                <div
                  className="fs-13 fw-700 textcolor flex-grow-1 text-end px-3"
                  style={{ flex: 1.5 }}
                >
                  Received Amount
                </div>
                <div
                  className="fs-13 fw-700 textcolor flex-grow-1 text-end px-3"
                  style={{ flex: 1.5 }}
                >
                  Outstanding
                </div>
                <div
                  className="fs-13 fw-700 textcolor flex-grow-1 px-3"
                  style={{ flex: 1 }}
                >
                  Status
                </div>
              </div>

              {/* Table Body */}
              <div>
                {loading ? (
                  <div className="text-center py-4">Loading...</div>
                ) : paymentList.length === 0 ? (
                  <div className="text-center py-4">No payments found</div>
                ) : (
                  paymentList.map((item, index) => (
                    <div
                      key={item.id}
                      className="d-flex w-100 align-items-center px-2 py-2 border-bottom"
                      style={{
                        backgroundColor:
                          hoveredIndex === index ? "#FAFAFA" : "#FFFFFF",
                        cursor: "pointer",
                        height: "40px",
                      }}
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                      onClick={() =>
                        navigate("/payment/view", {
                          state: { customerId: item.vendor_id },
                        })
                      }
                    >
                      {/* Customer */}
                      <div
                        className="d-flex align-items-center flex-grow-1 px-3"
                        style={{ flex: 2 }}
                      >
                        <img
                          src={item.profile ? item.profile : profileIc}
                          onClick={(e) => {
                            e.stopPropagation();
                            openFile(item.profile ? item.profile : profileIc);
                          }}
                          alt="Profile"
                          className="rounded-circle me-2"
                          style={{ width: "24px", height: "24px" }}
                        />
                        <span className="fs-13 fw-500 textcolor">
                          {item.name || "-"}
                        </span>
                      </div>

                      {/* Total Revenue */}
                      <div
                        className="fs-13 fw-500 textcolor flex-grow-1 px-3"
                        style={{ flex: 1.5 }}
                      >
                        <span
                          dangerouslySetInnerHTML={{
                            __html: item.symbol || "&#8377;",
                          }}
                        />
                        {item.total_revenue || 0}
                      </div>

                      {/* Invoices */}
                      <div
                        className="fs-13 fw-500 textcolor flex-grow-1 px-3"
                        style={{ flex: 1 }}
                      >
                        {item.invoices || 0}
                      </div>

                      {/* Received Amount */}
                      <div
                        className="fs-13 fw-500 textcolor flex-grow-1 text-end px-3"
                        style={{ flex: 1.5 }}
                      >
                        <span
                          dangerouslySetInnerHTML={{
                            __html: item.symbol || "&#8377;",
                          }}
                        />
                        {item.received_amount || 0}
                      </div>

                      {/* Outstanding */}
                      <div
                        className="fs-13 fw-500 textcolor flex-grow-1 text-end px-3"
                        style={{ flex: 1.5 }}
                      >
                        <span
                          dangerouslySetInnerHTML={{
                            __html: item.symbol || "&#8377;",
                          }}
                        />
                        {item.outstanding || 0}
                      </div>

                      {/* Status */}
                      <div
                        className="fs-13 fw-500 textcolor flex-grow-1 d-flex align-items-center px-3"
                        style={{ flex: 1, position: "relative" }}
                      >
                        <span
                          className="me-2"
                          style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            backgroundColor:
                              item.status === "Completed"
                                ? "#4EBD7E"
                                : item.status === "Partial"
                                  ? "#FFB31F"
                                  : "#FF7F37",
                          }}
                        ></span>
                        {item.status}
                        {hoveredIndex === index && (
                          <div
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              display: "flex",
                              gap: "8px",
                            }}
                          >
                            {/* {checkPermission("Vendors", "edit_permission") && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate("/payment/create", {
                                    state: { id: item.id },
                                  });
                                }}
                                style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "28px", height: "28px", borderRadius: "100px", background: "#FFFFFF", cursor: "pointer", border: "0.8px solid #E5E5E5" }}
                              >
                                <EditIc />
                              </div>
                            )}
                            {checkPermission("Vendors", "delete_permission") && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setDeleteId(item.id);
                                }}
                                style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "28px", height: "28px", borderRadius: "100px", background: "#FFFFFF", cursor: "pointer", border: "0.8px solid #E5E5E5" }}
                              >
                                <DeleteIc />
                              </div>
                            )} */}
                          </div>
                        )}
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
          )}

          {/* Grid View */}
          {active === "grid" && (
            <div className="mt-3">
              {loading ? (
                <div className="text-center py-4">Loading...</div>
              ) : paymentList.length === 0 ? (
                <div className="text-center py-4">No payments found</div>
              ) : (
                paymentList.map((item, index) => (
                  <div
                    key={item.id}
                    className="bg-white rounded-4 p-3 mb-3 d-flex align-items-center justify-content-between border"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      navigate("/payment/view", {
                        state: { customerId: item.vendor_id },
                      })
                    }
                  >
                    <div className="d-flex align-items-center gap-3">
                      <img
                        src={item.profile ? item.profile : profileIc}
                        onClick={(e) => {
                          e.stopPropagation();
                          openFile(item.profile ? item.profile : profileIc);
                        }}
                        alt="Profile"
                        className="rounded-circle"
                        style={{ width: "48px", height: "48px" }}
                      />
                      <div>
                        <div className="fs-14 fw-600 textcolor">
                          {item.name || "-"}
                        </div>
                      </div>
                    </div>

                    <div className="d-flex flex-column gap-1">
                      <span className="fs-12 textGrey">Total Amount</span>
                      <span className="fs-13 fw-600 textcolor">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: item.symbol || "&#8377;",
                          }}
                        />
                        {item.total_revenue || 0}
                      </span>
                    </div>

                    <div className="d-flex flex-column gap-1">
                      <span className="fs-12 textGrey">Received</span>
                      <span className="fs-13 fw-600 textcolor">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: item.symbol || "&#8377;",
                          }}
                        />
                        {item.received_amount || 0}
                      </span>
                    </div>

                    <div className="d-flex flex-column gap-1">
                      <span className="fs-12 textGrey">Outstanding</span>
                      <span className="fs-13 fw-600 textcolor">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: item.symbol || "&#8377;",
                          }}
                        />
                        {item.outstanding || 0}
                      </span>
                    </div>

                    <div>
                      <span
                        className="px-3 py-1 rounded-pill fs-12 fw-500"
                        style={{
                          backgroundColor:
                            item.status === "Completed"
                              ? "#E5FFF0"
                              : item.status === "Partial"
                                ? "#FFF5E2"
                                : "#FFF0EB",
                          color:
                            item.status === "Completed"
                              ? "#4EBD7E"
                              : item.status === "Partial"
                                ? "#FFB31F"
                                : "#FF7F37",
                        }}
                      >
                        {item.status}
                      </span>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}

          {/* Pagination */}
          <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3 px-2">
            <Dropdown>
              <span className="fs-12 fw-600 textcolor me-2">
                Records per page :
              </span>
              <Dropdown.Toggle
                variant="light"
                className="bg-white border textcolor rounded-3 px-2 py-1 fs-12 fw-600"
                style={{ minWidth: "50px" }}
              >
                {itemsPerPage} <DownArrowIc />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {[10, 25, 50].map((size) => (
                  <Dropdown.Item
                    key={size}
                    onClick={() => {
                      setItemsPerPage(size);
                      setItemOffset(0);
                      setCurrentPage(0);
                    }}
                  >
                    {size}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            <ReactPaginate
              previousLabel={
                <div
                  className="rounded-circle bg-white d-flex align-items-center justify-content-center border"
                  style={{ width: "32px", height: "32px" }}
                >
                  <LarIc />
                </div>
              }
              nextLabel={
                <div
                  className="rounded-circle bg-white d-flex align-items-center justify-content-center border"
                  style={{ width: "32px", height: "32px" }}
                >
                  <RarIc />
                </div>
              }
              breakLabel={"..."}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              forcePage={currentPage}
              containerClassName={
                "pagination d-flex gap-2 align-items-center list-unstyled mb-0"
              }
              activeClassName={"active"}
              pageClassName={"page-item"}
              pageLinkClassName={
                "page-link rounded-circle border-0 fs-12 fw-600 textcolor d-flex align-items-center justify-content-center"
              }
              activeLinkClassName={"bg-primary1 text-white"}
            />
          </div>
        </div>
      </div>
      {/* Hidden Input field for Excel Upload */}
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept=".xlsx, .xls"
        onChange={handleExcelFileUploaded}
      />
      {/* Import Bulk Excel Modal */}
      <Modal
        show={showImportModal}
        onHide={() => {
          setShowImportModal(false);
          setSelectedFile(null);
        }}
        centered
        className="import-file-modal"
      >
        <Modal.Header className="border-0 p-4 pb-0 position-relative">
          <div className="w-100">
            <h3 className="modal-title fw-bold fs-24 mb-1">Import File</h3>
            <p className="text-muted fs-14 mb-0">
              Choose an Excel file and import all the data from that.
            </p>
          </div>
          <div
            className="close-btn-custom-import"
            onClick={() => {
              setShowImportModal(false);
              setSelectedFile(null);
            }}
            style={{
              cursor: "pointer",
              position: "absolute",
              top: "20px",
              right: "20px",
            }}
          >
            <CloseIc style={{ width: "16px" }} />
          </div>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div
            className="upload-area-custom d-flex flex-column align-items-center justify-content-center"
            onClick={handleSelectExcelFileClick}
            style={{ cursor: "pointer" }}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            {selectedFile ? (
              <>
                <div
                  className="upload-icon-circle mb-3"
                  style={{ backgroundColor: "#EEF2FF" }}
                >
                  <FileAddIc
                    style={{ width: "24px", height: "24px", color: "#4F46E5" }}
                  />
                </div>
                <h5 className="fs-16 fw-700 mb-1 text-primary-blue">
                  File Selected
                </h5>
                <p className="text-muted fs-13 mb-3 fw-500">
                  {selectedFile.name} ({(selectedFile.size / 1024).toFixed(1)}{" "}
                  KB)
                </p>
                <button
                  className="btn-select-file text-nowrap"
                  style={{ minWidth: "max-content" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedFile(null);
                  }}
                >
                  Remove File
                </button>
              </>
            ) : (
              <>
                <div className="upload-icon-circle mb-3">
                  <FileAddIc style={{ width: "24px", height: "24px" }} />
                </div>
                <h5 className="fs-16 fw-700 mb-1">Drag and drop your files</h5>
                <p className="text-muted fs-12 mb-3">
                  Only Excel file format (Max. Size 5MB)
                </p>
                <button
                  className="btn-select-file d-flex align-items-center justify-content-center gap-2 text-nowrap"
                  style={{ minWidth: "max-content" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSelectExcelFileClick();
                  }}
                >
                  <PlusImageIc style={{ width: "14px", height: "14px" }} />{" "}
                  Select File
                </button>
              </>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0 p-4 pt-0 d-flex justify-content-between">
          <button
            className="btn-template-custom"
            onClick={downloadTemplateExcel}
            disabled={templateLoading}
          >
            {templateLoading ? (
              "Downloading..."
            ) : (
              <>
                <DownloadIc style={{ width: "16px", height: "16px" }} />{" "}
                Template
              </>
            )}
          </button>
          <div className="d-flex gap-3">
            <button
              className="btn-cancel-custom-modal"
              onClick={() => {
                setShowImportModal(false);
                setSelectedFile(null);
              }}
            >
              Cancel
            </button>
            <button
              className="btn-upload-custom"
              onClick={handleUploadClick}
              disabled={!selectedFile || importLoading}
            >
              {importLoading ? "Uploading..." : "Upload"}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
}

export default PaymentListingPage;
